module.exports = __webpack_public_path__ + "img/badge.e3e3dbcf.svg";